export default __webpack_public_path__ + "static/px6-2e002f5b45c3438cde78c0f2b1c50985.jpg";